import React, { useEffect, useState } from "react";
import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";

import { useNavigate } from "react-router";
import { Tooltip } from "@progress/kendo-react-tooltip";
import Loader from "../../control-components/loader/loader";
import { Grid, GridColumn, } from "@progress/kendo-react-grid";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import SearchModel from "./search-model";
import { MaskFormatted } from "../../helper/mask-helper";

import APP_ROUTES from "../../helper/app-routes";
import { staffService } from "../../services/staffService";
import { NotificationManager } from "src/util/notify";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const StaffSearch = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [client, setClient] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [finalValue, setFinalValue] = useState();
  const [isAllSelected, setAllSelected] = useState(false);
  const [checkedStaff, setCheckedStaff] = React.useState([]);
  const [checkedActiveStaff, setCheckedActiveStaff] = useState([]);
  const [currentMasterClinicId, setCurrentMasterClinicId] = useState();
  const [currentRegionId, setCurrentRegionId] = useState();
  const [showDialog, setShowDialog] = useState();
  const [cancelSendWelcomeEmail, setCancelSendWelcomeEmail] = useState(true)


  const fetchFromParent = (clientList) => {
    setClient(clientList);
  };

  useEffect(() => {
    if (client && client.length > 0) {
      setCurrentMasterClinicId(client[0].masterClinicId);
      setCurrentRegionId(client[0].regionId);
    }
  }, [client])

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
    let newValue = skip / take;
    let finalValue = newValue + 1;
    setFinalValue(finalValue);
    setAllSelected(false)
  };

  const handleAddStaff = () => {
    navigate(APP_ROUTES.ADD_STAFF);
  };
  const impersonateStaff = (staffid, masterClinicId) => {
    setLoading(true);
    staffService.impersonateStaff(staffid, masterClinicId).then((result) => {
      setLoading(false);
      let url = result.resultData?.redirectUrl;
      window.open(url, '_blank');
    }).catch((error) => {
      setLoading(false);
    });
  }



  useEffect(() => {
    if (checkedStaff.length > 0) {
      const activeStaff = checkedStaff.filter(doc => doc.isActive);
      setCheckedActiveStaff(activeStaff)
    }
    else {
      setCheckedActiveStaff([])
    }
  }, [checkedStaff])



  const onHeaderSelectionChange = React.useCallback((event) => {
    const checked = event.syntheticEvent.target.checked;
    setAllSelected(checked)
    let data = event.dataItems
    if (data.length > 0) {

      data.map(function (e) {
        e.isSelected = false;
      });
      if (checked) {
        setCheckedStaff(data)
      } else {
        setCheckedStaff([])
        setCheckedActiveStaff([])
      }
    }
  }, []);

  const handleClearGrid = () => {
    setClient([])
    // setTotal(0);    
    setPage(0);
    setPageSize(10);
    setFinalValue(1);
  }

  const handleSendWelcomeEmail = async (staffId, regionId, masterClinicId, selectedStaffActive) => {
    if (checkedActiveStaff.length > 0) {
      if (!cancelSendWelcomeEmail) {
        const idscheckedActiveStaff = checkedActiveStaff?.map(staff => staff?.staffId);
        const response = await staffService.sendStaffWelcomeEmail(idscheckedActiveStaff, regionId, masterClinicId)
        if (showDialog) {
          setShowDialog(false);
        }
        if (response.statusCode === 200) {
          NotificationManager.success('Emails sent successfully');
        }
      }
    }
    else {
      if (!selectedStaffActive) {
        NotificationManager.warning('Selected staff is not active')
      }
      if (selectedStaffActive) {
        const idToSend = []
        idToSend.push(staffId)
        const response = await staffService.sendStaffWelcomeEmail(idToSend, regionId, masterClinicId)
        if (response.statusCode === 200) {
          NotificationManager.success('Email sent successfully')
        }
      }
    }
  }
  const onSelectionChange = (event) => {
    const item = event.dataItem;
    const isSelected = event.nativeEvent.target.checked;

    if (isSelected) {
      setCheckedStaff([...checkedStaff, item]);
    }
    else {
      setCheckedStaff(checkedStaff?.filter((obj) => obj.staffId !== item.staffId));
    }
  };


  return (
    <>
      
      <h4 className="address-title text-grey ">
        <span className="f-24">Staff</span>
      </h4>
      <div className="align-items-end">
        <SearchModel
          page={page}
          pageSize={pageSize}
          finalValue={finalValue}
          fetchFromParent={fetchFromParent}
          setLoading={setLoading}
          onClear={handleClearGrid}
        />
      </div>
      <div className="d-flex justify-content-end p-3 pb-0">
        <button
          onClick={() => { setShowDialog(true); if (checkedActiveStaff.length === 0) { NotificationManager.warning('You have not selelcted any staff yet please select a staff to continue'); setShowDialog(false) } }}
          className="green-btn btn-primary mt-3"
        >
          <span className="p-2 fas fa-paper-plane" style={{ color: "#fff" }}></span> Send Welcome Email
        </button>
        <button onClick={handleAddStaff} className="green-btn btn-primary mt-3 ms-4">
          <span className="k-icon k-font-icon k-i-plus" style={{ color: "#fff" }}></span> Add Staff
        </button>
      </div>
      <div className=" filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue" style={{ width: "100%", overflowX: "auto" }}>
              <div className=" mt-3">
                {loading === true ? <Loader />:
                  (client && client.length > 0) ? <Grid
                    data={orderBy(client.slice(page, pageSize + page), sort).map(
                      (item) => ({
                        ...item,
                        [SELECTED_FIELD]: selectedState[idGetter(item)],
                        masterClinicId: item.masterClinicId,
                        id: item.staffId,
                        stripeCustomerInfo: item.stripeCustomerId,
                      })
                    )}
                    checkboxElement
                    style={{
                      height: client.length > 0 ? "100%" : "250px",
                    }}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    skip={page}
                    take={pageSize}
                    total={client.length}
                    onPageChange={pageChange}
                    pageable={{
                      pageSizes: [10, 20, 30, 50, 100, 500],
                    }}
                    sort={sort}
                    sortable={true}
                    onSortChange={(e) => {
                      setSort(e.sort);
                    }}
                    onHeaderSelectionChange={onHeaderSelectionChange}
                    selectable={{
                      enabled: true,
                      checkboxOnly: true,
                      mode: "multiple"
                    }}
                    onSelectionChange={onSelectionChange}
                  >
                    <GridColumn
                      width="105px"
                      headerSelectionValue={isAllSelected}
                      field={SELECTED_FIELD}
                      columnType="checkbox"
                    />

                    <GridColumn
                      className="cursor-default"
                      field="staffId"
                      title="Staff ID"
                      width="105px"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem;

                          return (
                            <td>
                              <span>{field.staffId}</span>
                              <i
                                className="fa-solid fa-shuffle"
                                style={{ fontSize: 20, cursor: "pointer", marginLeft: 10 }}
                                onClick={() => impersonateStaff(field.staffId, field.masterClinicId)}
                              ></i>
                            </td>
                          );
                        }
                      }}
                    />


                    <GridColumn
                      className="cursor-default"
                      field="staffName"
                      title="Staff Name"
                      width="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="userName"
                      title="Username"
                      width="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="roleName"
                      title="Role"
                      width="150px"
                    />

                    <GridColumn
                      className="cursor-default"
                      field="email"
                      title="E-mail"
                      width="220px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="mobile"
                      title="Mobile"
                      width="150px"
                      cells={{
                        data: (props) => {
                          let field = MaskFormatted(
                            props.dataItem.mobile,
                            "(999) 999-9999"
                          );
                          return <td className="cursor-default">{field}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="genderName"
                      title="Gender"
                      width="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="clinicName"
                      title="Clinic"
                      width="150px"
                      cells={{
                        data: (props) => {
                          let field = { ...props.dataItem, masterClinicId: props.dataItem.clinicId };
                          return (
                            <td
                              className="text-theme"
                              style={{ cursor: "pointer" }}
                              onClick={() => {

                                navigate(APP_ROUTES.CLINIC_INFO, {
                                  state: { field },
                                })
                              }}
                            >
                              {field.clinicName} ({field.masterClinicId})
                            </td>
                          );
                        }
                      }}
                    />


                    <GridColumn
                      className="cursor-default"
                      field="positionName"
                      width="150px"
                      title="Position Name"
                    />
                    <GridColumn
                      className="cursor-default"
                      title="Active?"
                      width="80px"
                      field="isActive"
                      cells={{
                        data: (props) => {

                          return <td className="cursor-default">{props.dataItem.isActive === true ? "Yes" : "No"}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      title="SystemUser?"
                      width="120px"
                      field="isSystemUser"
                      cells={{
                        data: (props) => {

                          return <td className="cursor-default">{props.dataItem.isSystemUser === true ? "Yes" : "No"}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      title="Action"
                      width="95px"
                      filterable={false}
                      cells={{
                        data: (props) => {
                          let field = props.dataItem;
                          return (
                            <td>
                              <div className="row-3">
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                  onClick={() =>
                                    navigate(APP_ROUTES.ADD_STAFF, {
                                      state: field,
                                    })
                                  }
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i className="fas fa-edit" title="Edit"></i>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                              {/* <span className='k-icon k-i-delete text-danger' onClick={() => deleteAuth(field)} />
                           <span style={{ marginLeft: '20px' }} className='k-icon k-i-edit' onClick={() => editAuth(field)} /> */}
                              {props.dataItem.isActive && <div
                                className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                onClick={() =>
                                  // navigate(APP_ROUTES.ADD_STAFF, {
                                  //   state: field,
                                  // })
                                  handleSendWelcomeEmail(props.dataItem.staffId, props.dataItem.regionId, props.dataItem.masterClinicId, props.dataItem.isActive)
                                }
                              >
                                <div className="k-chip-content">
                                  <Tooltip anchorElement="target" position="top">
                                    <i className="fas fa-paper-plane" title="Send Welcome Email"></i>
                                  </Tooltip>
                                </div>
                              </div>}
                            </td>
                          );
                        }
                      }}
                    />

                  </Grid>
                    : <div className="recordsNotFound">No records available
                    </div>
                }

              </div>
            </div>
          </div>
        </div>
      </div>
      {showDialog &&
        <Dialog title={"Confirm Send Welcome Email"} onClose={() => setShowDialog(false)}>
          <h5
            style={{
              margin: "25px",
              textAlign: "center",
            }}
          >
            Are you sure that you want to send welcome emails to the below given staffs again
          </h5>
          <ul>
            {checkedActiveStaff.map((staff, index) => (
              <li key={index}>Email is being sent to {staff?.staffName}</li>
            ))}
          </ul>
          <DialogActionsBar>
            <button
              className="common-btn-size k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={() => { setCancelSendWelcomeEmail(false); handleSendWelcomeEmail(0, currentRegionId, currentMasterClinicId, false) }}
            >
              Yes
            </button>
            <button
              className="common-btn-size k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={() => { setShowDialog(false); setCancelSendWelcomeEmail(true) }}
            >
              No
            </button>
          </DialogActionsBar>
        </Dialog>
      }
    </>
  );
};

export default StaffSearch;
